import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AppsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"apps"}/>
}
